/** basic.modelCommand */
export default {
    modelNum_orderName: "Название команды",
    modelNum_orderNamePla: "Введите название команды",
    modelNum_modelNum: "Модель",
    modelNum_editOrderTitle: "Изменить команду модели",
    modelNum_addOrderTitle: "Новая команда модели",
    modelNum_orderArgument: "Параметры команды",
    modelNum_copy: "Копировать",
    modelNum_copySucc: "Скопировано",
    modelNum_JsonText: "Редактировать параметры шаблона",
    modelNum_modelPla: "Введите название модели",
    modelNum_ruleOrder: "Название команды не может быть пустым!",
    modelNum_ruleModelNum: "Модель не может быть пустой",
    modelNum_orderArgumentPla: "Параметры команды не могут быть пустыми",
    type_drawerTitle: "Детали типа устройства",
    message_addOrderSucc: "Команда добавлена!",
    message_addOrderLose: "Не удалось добавить команду!",
    message_editOrderSucc: "Команда изменена!",
    message_editOrderLose: "Не удалось изменить команду!",
}

